import { Component } from '@angular/core';
import { AppService } from '../../../services/app.service';
import { PaymentService } from '../../../services/payment.service';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { PaymentSearchCriteria } from '../../../model/common.model';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { TableModule } from 'primeng/table';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'brt-manage-payments',
  standalone: true,
  imports: [CommonModule, TableModule],
  templateUrl: './manage-payments.component.html',
  styleUrl: './manage-payments.component.css'
})
export class ManagePaymentsComponent {
  business?: any;
  criteria: PaymentSearchCriteria = {};
  loading = false;
  total: number;
  payments: any[];
  limit = 100;

  constructor(appService: AppService, private paymentService: PaymentService) {
    appService.activeBusiness$.pipe(takeUntilDestroyed()).subscribe( async business => {
      this.business = business;
      await this.load();
    });
  }

  async load() {
    this.loading = true;
    try {
      this.criteria.BusinessId = this.business.Id;
      const res = await this.paymentService.search(this.criteria, 0, this.limit);
      this.total = res.Total;
      this.payments = res.List;
    } finally {
      this.loading = false;
    }
  }
}
